import Vue from 'vue';
import '@babel/polyfill';
import './plugins/vuetify';
import * as Sentry from '@sentry/browser';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import filters from './util/filters';
import helpers from './util/helpers';
import axios from './config/axios';
import i18n from './i18n/i18n-config';
import eventBus from './util/event-bus';

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$eventBus = eventBus;

filters.registerFilters(Vue);
helpers.registerHelpers(Vue);

if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_KEY,
    integrations: [new Sentry.Integrations.Vue({ Vue })],
    ignoreErrors: [
      /(Unexpected token o in JSON at position 1)/, // dokobit iframe works, but keeps throwing this error
      /(unexpected character at line 1 column 1 of the JSON data)/, // dokobit iframe works, but keeps throwing this error
      /(Request failed with status code 422)/, // error responses from backend
    ],
  });
}

new Vue({
  store,
  i18n,
  router,
  render: h => h(App),
}).$mount('#app');
